import React from 'react';
import PropTypes from 'prop-types';
import { observer } from 'mobx-react';
import { linearModel } from 'mobx-store';

import { ParameterDropdown } from 'components/Dropdown';

import AlphaSlider from './AlphaSlider';

const SettingsFormComponent = observer(
  class SettingsFormComponent extends React.Component {
    static propTypes = {
      form: PropTypes.string.isRequired,

      onPrimaryParameterChange: PropTypes.func.isRequired,
      onSecondaryParameterChange: PropTypes.func.isRequired,

      primaryParameter: PropTypes.string.isRequired,
      secondaryParameterVisible: PropTypes.bool.isRequired,

      showEmptyDatasetWarning: PropTypes.bool.isRequired
    }

    render () {
      return (
        <div className="content-item" id="settings-form">
          <h2 className="header-page">
            Settings
          </h2>

          <ParameterDropdown
            form={this.props.form}
            name="primaryParameter"
            resetSecondaryParameter
            label="Explanatory Variable (x-axis)"
            id="primary-parameter-dropdown"
            onChange={this.props.onPrimaryParameterChange}
          />

          {this.props.secondaryParameterVisible &&
            <ParameterDropdown
              onlyNumerical
              form={this.props.form}
              name="secondaryParameter"
              label="Response Variable (y-axis)"
              id="secondary-parameter-dropdown"
              onChange={this.props.onSecondaryParameterChange}
              primaryParameterName={this.props.primaryParameter}
            />
          }

          {linearModel.areConfidenceIntervalsControlsVisible &&
            !this.props.showEmptyDatasetWarning &&
              <AlphaSlider />
          }

          {linearModel.categoricalParameterLevels &&
            linearModel.categoricalParameterLevels.length < 2 &&

            <span className="mt-10 mb-10 text-center">
              Categorical parameter should have at least two levels!
            </span>
          }

          {this.props.showEmptyDatasetWarning &&
            <p className="opacity-50 text-center">
              Your dataset is currently empty or insufficient, please remove a
              few filters or select a new dataset before continuing.
            </p>
          }
        </div>
      );
    }
  }
);

export default SettingsFormComponent;
